import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProductContext & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

export interface ProductDetailsPriceStyles {
    productPrice?: ProductPriceStyles;
    itemNotFound?: InjectableCss;
    notFoundLabel?: TypographyProps;
}

export const priceStyles: ProductDetailsPriceStyles = {
    productPrice: {
        price: {
            priceText: { size: 26 },
            unitOfMeasureText: { size: 26 },
        },
    },
    itemNotFound: {
        css: css`
            font-size: 14px;
            margin: 12px 0px;
            span {
                padding-right: 5px;
            }
        `,
    },
    notFoundLabel: {
        size: 14,
        weight: 700,
    },
};

const styles = priceStyles;

const ProductDetailsPrice: React.FC<OwnProps> = ({ productContext, productSettings }) => {
    const { productInfo } = productContext;
    let showPriceMessage = true;
    if (productInfo?.pricing?.additionalResults?.showContactUsMessage?.toLowerCase() === "true") {
        showPriceMessage = false;
    }
    if (!showPriceMessage) {
        return (
            <>
                <StyledWrapper>
                    <Typography {...styles.notFoundLabel}>{translate("List Price:")}</Typography>
                </StyledWrapper>
                <ProductPrice
                    product={productContext}
                    showLabel={false}
                    showSavings={true}
                    showSavingsAmount={productSettings.showSavingsAmount}
                    showSavingsPercent={productSettings.showSavingsPercent}
                    extendedStyles={styles.productPrice}
                />
                <StyledWrapper {...styles.itemNotFound}>
                    <Link href="/contact-kgpco">{translate("Contact Us")}</Link>
                    <Typography>{translate("for pricing & availability for this item.")}</Typography>
                </StyledWrapper>
            </>
        );
    }

    return (
        <>
            <StyledWrapper>
                <Typography {...styles.notFoundLabel}>{translate("Your Price:")}</Typography>
            </StyledWrapper>
            <ProductPrice
                product={productContext}
                showLabel={false}
                showSavings={true}
                showSavingsAmount={productSettings.showSavingsAmount}
                showSavingsPercent={productSettings.showSavingsPercent}
                extendedStyles={styles.productPrice}
            />
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProductContext(ProductDetailsPrice)),
    definition: {
        displayName: "Price",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
